import {Link} from "gatsby";
import React, {useEffect, useState, useRef} from "react";
import styled from 'styled-components';
import Container from "../atoms/Container";
import Logo from "../../assets/svg/logo-icon-weft.inline.svg";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { throttle } from 'lodash';

gsap.registerPlugin(ScrollTrigger);

const ExtraOuter = styled.div`
  position: sticky;
  top: -1px;
  left: 0;
  width: 100%;
  z-index: 2;
`;

const Outer = styled.div`
  background: black;
  transform: ${props => props.show ? 'translateY(0)' : 'translateY(-100%)'};
  transition: transform 0.25s ease-in-out;
`;

const Holder = styled.div`
  display: grid;
  padding: 0.5rem 0;
  
  ${(props) => props.theme.fluidType(-1)} @media (${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: 2fr 3fr;
    column-gap: 1rem;
  }
`;

const IconHolder = styled.div`
  width: 48px;
  margin-bottom: 1rem;
  @media (${(props) => props.theme.breakpoints.md}) {
    width: 78px;
    margin-bottom: 0;
  }

  svg {
    width: 100%;
    padding: 0.5rem 0;
    height: auto;
    display: block;
  }
`;

const NavHolder = styled.div`
  padding: 0;
  display: flex;
  justify-content: space-between;

  @media (${(props) => props.theme.breakpoints.md}) {
    // display: grid;
    // grid-template-columns: repeat(3, 1fr);
    align-items: end;
  }

  p {
    margin: 0;
  }

  a {
    color: #3ED3CB;
    font-family: "Inter", sans-serif;
    font-weight: 700;
    text-decoration: none;
  }

  a[aria-current="page"] {
    color: #FF00FF;
  }
`;

const Spacer = styled.div`
  height: 100vh;
`;


function Header() {

  const [show, setShow] = useState(true)
  const [lastScrollTop, setLastScrollTop] = useState(0)

  useEffect(() => {

    const onScroll = () => {
      let st = window.pageYOffset || document.documentElement.scrollTop
      if (st > lastScrollTop) {
        // downscroll
        setShow(false)
      } else {
        // upscroll
        setShow(true)
      }
      setLastScrollTop(st <= 0 ? 0 : st)
    }

    const throttledCount = throttle(onScroll, 100)
    window.addEventListener('scroll', throttledCount)
    return () => window.removeEventListener('scroll', throttledCount)

  }, [lastScrollTop])

  return (
    <ExtraOuter>
      <Outer show={show}>
        <Container>
          <Holder>
            <IconHolder className="logo">
              <Link to="/"><Logo /></Link>
            </IconHolder>
            <NavHolder>
              <p>
                <Link to="/Work">Our Work</Link>
              </p>
              <p>
                <Link to="/Perspectives">Our Perspectives</Link>
              </p>
              <p>
                <Link to="/Team">Our Team</Link>
              </p>
            </NavHolder>
          </Holder>
        </Container>
      </Outer>
    </ExtraOuter>
  );
}

export default Header;
